<div class="d-flex flex-column justify-content-center align-content-center position-relative">
  <div class="message-container">
    <div class="message-title d-flex justify-content-center mt-4 mb-3 fs-18">
      {{data.msg}}
    </div>
  </div>
  <img src="assets/svg/close.svg"
       (click)="closeModal()"
       alt="remove"
       class="remove-icon cursor-pointer"/>
  <div class="d-flex align-content-center justify-content-center">
    <button mat-button
            (click)="redirect()"
            class="mr-2 button-primary mat-button-base p-0">
      Subscribe
    </button>
  </div>
</div>
